import styled, { keyframes } from 'styled-components';
import { body2, colors, duration, easing, spacing } from 'ui/theme';

const slideFromLeft = keyframes({
  '0%': { transform: 'translateX(-100px)' },
  '100%': { transform: 'translateX(0)' },
});

const slideFromRight = keyframes({
  '0%': { transform: 'translateX(100px)' },
  '100%': { transform: 'translateX(0)' },
});

const fadeIn = keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 1 },
});

const fadeOut = keyframes({
  '0%': { opacity: 1 },
  '100%': { opacity: 0 },
});

export const CastTypeSelectWrapper = styled.div`
  animation-duration: ${duration.short};
  animation-fill-mode: forwards;

  &[data-slide='left'] {
    animation-name: ${fadeIn};
  }

  &[data-exit='right'] {
    animation-name: ${fadeOut};
  }

  animation-timing-function: ${easing.standard};

  display: flex;
  flex-direction: row;
  column-gap: ${spacing.half};
  align-items: center;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: ${spacing.half};
  align-items: center;
`;

export const CastTypeTriggerWrapper = styled.div`
  animation-duration: ${duration.short};
  animation-fill-mode: forwards;

  &[data-slide='left'] {
    animation-name: ${slideFromLeft};
  }

  &[data-slide='right'] {
    animation-name: ${slideFromRight};
  }
  animation-timing-function: ${easing.standard};
`;

export const CastTypePrefix = styled.span`
  ${body2}
  color: ${colors.textSecondary};
`;
